export const AccountValidationState = {
    NONE: 'none',
    VALIDATING: 'validating',
    WRONG_ID: 'wrongId',
    CORRECT_ID: 'correctId',
};

export const mapValidationStateToCSS = {
    [AccountValidationState.NONE]: '',
    [AccountValidationState.VALIDATING]: 'validating',
    [AccountValidationState.WRONG_ID]: 'wrong',
    [AccountValidationState.CORRECT_ID]: 'correct',
}


export const getValidationStateTitle = (state, t) => {
    switch (state) {
        case AccountValidationState.VALIDATING:
            return t('validation.searching');
        case AccountValidationState.WRONG_ID:
            return t('validation.invalid');
        case AccountValidationState.CORRECT_ID:
            return t('validation.valid');
        default:
            return '';
    }
};
